export default __webpack_public_path__ + "img/bd1662055253bcd5cf833243cb887288.png";